/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const syncVariantElements = (variantId) => {
    if (!variantId) {
      return
    }
    
    document.querySelectorAll('[data-variant-id]').forEach((element) => {
      const elementVariantId = element.getAttribute('data-variant-id');

      // If variant ids match
        if (variantId == elementVariantId) {
          //remove the class that hides the element if it's there
            if (element.classList.contains('variant-data-hidden')) {
                element.classList.remove('variant-data-hidden');
            }
          //Mark the active variant price so Synchrony can use this to calculate estimated payment.
            if (element.classList.contains('variant-price') && !element.classList.contains('active-variant-price')) {
                element.classList.add('active-variant-price');
            }
        } else { // If variant ids don't match
          //add the class that hides the element, if it's not there
            if (!element.classList.contains('variant-data-hidden')) {
                element.classList.add('variant-data-hidden');
            }
          //Un-mark as active variant prices that are not for the active variant. Used by Synchrony to calculate estimated payment.
            if (element.classList.contains('variant-price') && element.classList.contains('active-variant-price')) {
                element.classList.remove('active-variant-price');
            }
        }
    });
  }
  
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.

    const variant = event.detail.variant;

    if (variant) {
      syncVariantElements(variant?.id);
    }
    
  });

  /*
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  
  // Fired when page loads to update header values 
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });
  */

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


//Show and hide contact forms with a button
function showForm() {
  document.getElementById("airparkForm").style.display = "block";
  document.getElementById("airparkShowFormButton").style.display = "none";
  document.getElementById("airparkHideFormButton").style.display = "block";
}

function hideForm() {
  document.getElementById("airparkForm").style.display = "none";
  document.getElementById("airparkShowFormButton").style.display = "block";
  document.getElementById("airparkHideFormButton").style.display = "none";
}
//END Show and hide contact forms with a button


//Show and hide contact forms with a button 2. Use this for the second form if there are two forms on the same page.
function showForm2() {
  document.getElementById("airparkForm2").style.display = "block";
  document.getElementById("airparkShowFormButton2").style.display = "none";
  document.getElementById("airparkHideFormButton2").style.display = "block";
}

function hideForm2() {
  document.getElementById("airparkForm2").style.display = "none";
  document.getElementById("airparkShowFormButton2").style.display = "block";
  document.getElementById("airparkHideFormButton2").style.display = "none";
}
//END Show and hide contact forms with a button 2.